import { Outlet } from "react-router-dom";
import styled from "styled-components";
import MapContainer from "../Other/MapContainer";
import appConfig from "../../lib/appConfig";
import ContextProvider from "../../context/ContextProvider";
import DialogContainer from "../Other/DialogContainer";

const MapPageLayoutContainer = styled.main`
  position: relative;
  height: calc(100vh - ${appConfig.headerHeight}px);
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${appConfig.tabletWidth}px) {
    flex-direction: column-reverse;
  }
`;

function MapPageLayout() {
  return (
    <ContextProvider>
      <MapPageLayoutContainer>
        <Outlet />
        <MapContainer />
        <DialogContainer />
      </MapPageLayoutContainer>
    </ContextProvider>
  );
}

export default MapPageLayout;
